import React, { ChangeEvent, useEffect, useLayoutEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getAppLang } from '../../../../../../utils/common-i18n';
import { Button, TextInput } from '../../../../components';
import TextArea from '../../../../components/textarea';
import { i18n } from '../../../../helpers/i18n';
import { useActions } from '../../../../hooks';
import { sendSupportFeedbackAction, supportFormWasShownAction } from '../../../settings';
import { SESSION_STORAGE_DESCRIPTION_KEY, SESSION_STORAGE_EMAIL_KEY } from '../../../settings/constants';
import { getUserSelector } from '../../../user';
import { EMAIL_REGEX } from '../../constants';
import css from './feedback-form.css';

export const FeedbackForm = () => {
    const dispatch = useDispatch();
    const user = useSelector(getUserSelector);
    const yandexDomain = getAppLang() === 'ru' ? 'yandex.ru' : 'yandex.com';
    const userEmail = user?.login?.includes?.('@') ? user.login : `${user?.login}@${yandexDomain}`;
    const [description, setDescription] = useState<string>('');
    const [email, setEmail] = useState<string>(user ? userEmail : '');
    const [emailError, setEmailError] = useState<boolean>(false);
    const [descriptionError, setDescriptionError] = useState<boolean>(false);
    const onSubmit = () => {
        const isEmailValid = EMAIL_REGEX.test(email);
        const isDescriptionValid = description.length > 0;
        if (isEmailValid && isDescriptionValid) {
            dispatch(sendSupportFeedbackAction({ email, description }));
        }
        setEmailError(!isEmailValid);
        setDescriptionError(!isDescriptionValid);
    };

    const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setEmail(value);
        sessionStorage.setItem(SESSION_STORAGE_EMAIL_KEY, value);
    };

    const onDescriptionChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        const value = event.target.value;
        setDescription(value);
        sessionStorage.setItem(SESSION_STORAGE_DESCRIPTION_KEY, value);
    };

    useLayoutEffect(() => {
        const email = sessionStorage.getItem(SESSION_STORAGE_EMAIL_KEY);
        const description = sessionStorage.getItem(SESSION_STORAGE_DESCRIPTION_KEY);
        if (email) {
            setEmail(email.toString());
        }
        if (description) {
            setDescription(description.toString());
        }
    }, []);

    const actions = useActions({ supportFormWasShownAction });

    useEffect(() => {
        actions.supportFormWasShownAction();
    }, [actions, actions.supportFormWasShownAction]);

    return (
        <div className={css.feedbackForm}>
            <TextInput
                value={email}
                onChange={onEmailChange}
                size="md"
                name="email"
                error={emailError ? 'error' : undefined}
                placeholder={i18n('feedback', 'feedback-email-hint')}
            />
            <TextArea
                value={description}
                onChange={onDescriptionChange}
                size="md"
                name="description"
                maxLength={3000}
                placeholder={i18n('feedback', 'feedback-description-hint')}
                rows={4}
                error={descriptionError ? 'error' : undefined}
            />
            <Button size="md" view="brand" onClick={onSubmit}>
                {i18n('feedback', 'submit')}
            </Button>
        </div>
    );
};
